import { render, staticRenderFns } from "./dashboardAccountActivate.vue?vue&type=template&id=9a30bd58&"
import script from "./dashboardAccountActivate.vue?vue&type=script&lang=js&"
export * from "./dashboardAccountActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports